<template>
<div class="article padding-20 bgc box-shadow">
    <keep-alive include="articleList">
        <router-view></router-view>
    </keep-alive>
</div>
</template>

<script>
export default {
    name: 'article1',
    data() {
        return {}
    },
    mounted() {
    },
    methods: {
    },
    filters: {
    },
    watch: {},
    computed: {
    },
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.article {
    // min-width: 1200px;
}
</style>